import { useMemo, useState } from 'react';
import { Button, Select } from '@mantine/core';
import MantineTable from '../../../../common/table/mantine';
import { Switch } from '@mantine/core';
import { useSwitchStyles } from '../budgetBomAdjustment';

export const Table = ({
  skus = [],
  setBomsModal,
  selectedSkus,
  handleRowSelection,
  plantId,
  skuId,
  selectedSkusDetails,
  readOnly = false,
  countries = [],
  fetchReferenceSkuByCountry,
  loading,
  selectedCountry,
  tabName,
  previewOnly,
}) => {
  const { classes } = useSwitchStyles();
  const { selectedData = {} } = selectedSkusDetails || {};
  const [onlyRecommended, showRecommendedSkus] = useState(false);

  const columns = useMemo(
    () =>
      [
        !previewOnly && {
          accessorKey: 'type',
          header: 'Type of SKU',
        },
        {
          accessorKey: 'sku',
          header: 'SKU Number',
        },
        {
          accessorKey: 'sku_description',
          header: 'SKU Description',
        },
        {
          accessorKey: 'plant',
          header: 'Production Plant',
        },
        {
          accessorKey: 'brand',
          header: 'Brand',
        },
        {
          accessorKey: 'container',
          header: 'Pack Type',
        },
        {
          id: 'bom',
          header: 'Show BOM',
          Cell: ({ row }) => (
            <Button
              color='dark'
              onClick={() =>
                setBomsModal({
                  open: true,
                  sku: row.original.sku,
                  plant: row.original.plant,
                })
              }
            >
              View BOM
            </Button>
          ),
        },
      ].filter((i) => i),
    [skus, selectedSkus, previewOnly],
  );

  const handleSelection = (data) => {
    handleRowSelection(data, plantId, skuId, tabName);
  };

  const isDisabled = (sku) => {
    const selectedDataLength = Object.keys(selectedData).length;
    return readOnly ? true : selectedDataLength >= 1 && !selectedData?.[sku.unique];
  };

  const leftButtons = [
    {
      button: (
        <Switch
          label='Show Recommended SKUs only'
          onChange={(event) => {
            showRecommendedSkus(event.target.checked);
          }}
          disabled={loading}
          classNames={{ input: classes.input, thumb: classes.thumb, track: classes.track }}
        />
      ),
    },
  ];

  const rightButtons = [
    {
      button: (
        <Select
          name='country'
          label=''
          placeholder='Select country'
          value={selectedCountry}
          data={countries}
          withAsterisk
          disabled={loading || readOnly}
          onChange={(value) => {
            handleSelection({});
            fetchReferenceSkuByCountry(value);
          }}
        />
      ),
    },
  ];

  return (
    <>
      <MantineTable
        columns={columns}
        initialData={(skus || []).filter(
          (ele) =>
            (onlyRecommended && (ele.type === 'RFS' || ele.type === 'Recommended')) ||
            !onlyRecommended,
        )}
        unique={'unique'}
        enableRowSelection={true}
        loading={loading}
        handleRowSelection={handleSelection}
        activeRows={previewOnly ? { ...selectedData, selected: true } : selectedData}
        showSelectedToggle={!previewOnly}
        hideSelectColumn={false}
        showResetAll={false}
        enableExport={true}
        pageSize={10}
        enableSelectAll={false}
        leftButtons={!previewOnly ? leftButtons : null}
        rightButtons={!onlyRecommended && !previewOnly ? rightButtons : null}
        initialState={{
          sorting: [
            {
              id: 'sku_description',
              desc: false,
            },
          ],
          showColumnFilters: true,
        }}
        positionToolbarAlertBanner={'none'}
        isRowDisabled={(row) => isDisabled(row)}
      />
    </>
  );
};
